import ShareOverlay from "./ShareOverlay";
export default ShareOverlay;


// WEBPACK FOOTER //
// ./src/ShareOverlay/index.js